import { useEffect, useState } from 'react';
import {
  getSplashCovering,
  getSplashPageReady,
  subscribeSplashCovering,
  subscribeSplashPageReady,
} from './splashGate';

/** True while the bootstrap splash still covers the app (opaque overlay over first screen). */
export function useSplashCovering(): boolean {
  const [covering, set_covering] = useState(getSplashCovering);
  useEffect(() => subscribeSplashCovering(set_covering), []);
  return covering;
}

/** True when the first screen reports it is ready to reveal under the splash. */
export function useSplashPageReady(): boolean {
  const [ready, set_ready] = useState(getSplashPageReady);
  useEffect(() => subscribeSplashPageReady(set_ready), []);
  return ready;
}
